
export const BUSSINESS_NAME = process.env.REACT_APP_BUSSINESS_NAME
export const APP_PUBLIC_URL = '/'

export const BASE_URL = process.env.REACT_APP_BASE_URL
const Version = "v1";

export const API_URL_ENDPOINT = {
    //auth
    Login: `${BASE_URL}/api/${Version}/Auth/signin`,


    BooksCategory: `${BASE_URL}/api/${Version}/Book/category`,
    BooksCategory: `${BASE_URL}/api/${Version}/Book/category`,
    Books: `${BASE_URL}/api/${Version}/Book`,

    // Book Operations
    ADD_BOOK: `${BASE_URL}/api/${Version}/Book`,

    Document: `${BASE_URL}/api/${Version}/Document`,
    Thought: `${BASE_URL}/api/${Version}/Thought`,
}
